// __APP_VERSION__/__APP_COMMIT__/__BUILD_DATE__/__APP_UPTIME__ are injected
// at build time (vite.config.js): version from package.json, commit hash
// from CI_COMMIT_SHORT_SHA or git, build date stamped at build time, uptime
// a static claim (no server-side monitoring exists to measure a real one).
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
export const APP_COMMIT = typeof __APP_COMMIT__ !== 'undefined' ? __APP_COMMIT__ : 'dev';
export const BUILD_DATE = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : '00000000';
export const APP_UPTIME = typeof __APP_UPTIME__ !== 'undefined' ? __APP_UPTIME__ : '99.999%';
